<template>
  <app-page-container title="گزارش زمان های فنس">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn @click="exportToExcel(headers, excelTableData, 'text', `fence_times_report_${page}`)" fab dark small
          color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header hide-default-header hide-default-footer :headers="headers"
                      :items="tableItems" :page.sync="page" :items-per-page="tableItems.length" height="69vh"
                      :search="searchTitle" multi-sort class="elevation-0 tt">
                      <template v-slot:header="props">
                        <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                          @group="props.on.group" />
                      </template>
                      <template v-slot:[`item.sendAgain`]="{ item }">
                        <v-row>
                          <v-checkbox v-model="item.sendAgain" :disabled="true"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-row>
                      </template>
                      <template v-slot:[`item.lackof`]="{ item }">
                        <v-row>
                          <v-checkbox v-model="item.lackof" :disabled="true"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-row>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0" class="pa-0">
                <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
      <section>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12" class="mt-n7">
                  <v-text-field type="number" dense outlined clearable clear-icon="mdi-close-circle-outline"
                    label="شماره پرونده" prepend-inner-icon="mdi-counter mdi-18px" autocomplete="off"
                    style="font-size: 11px !important" v-model="MissionIdentifier"
                    v-on:keyup.enter="search()"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-autocomplete :items="allUsers" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="fullName" item-value="id" label="کارشناس ارشد"
                    v-model="searchFirstUserId" autocomplete="off" prepend-inner-icon="mdi-account mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-autocomplete :items="allUsers" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="fullName" item-value="id" label="کارشناس اول"
                    v-model="searchSecondUserId" autocomplete="off" prepend-inner-icon="mdi-account mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-text-field type="text" v-model="searchPhoneCode" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="کد آمبولانس"
                    class="input-label" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="نوع وسیله نقلیه" v-model="searchVehicleTypeId" autocomplete="off"
                    prepend-inner-icon="mdi-ambulance mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهرستان"
                    v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-map mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-row>
                    <v-col cols="7" class="mt-3">
                      <span class="filter-dialog-items-text">حداقل زمان ابلاغ تا حرکت</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchDispatchTillMoveMinimumSecond" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchDispatchTillMoveMinimumMinute" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ثانیه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">دقیقه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-row>
                    <v-col cols="7" class="mt-3">
                      <span class="filter-dialog-items-text">حداقل زمان حرکت تا رسیدن</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchMoveTillArriveMinimumSecond" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchMoveTillArriveMinimumMinute" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ثانیه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">دقیقه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-row>
                    <v-col cols="7" class="mt-3">
                      <span class="filter-dialog-items-text">حداقل زمان حضور در محل</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchPatientWaitingDurationMinimumSecond" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchPatientWaitingDurationMinimumMinute" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ثانیه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">دقیقه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-row>
                    <v-col cols="7" class="mt-3">
                      <span class="filter-dialog-items-text">حداقل زمان حضور در بیمارستان</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchHospitalWaitingDurationMinimumSecond" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchHospitalWaitingDurationMinimumMinute" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ثانیه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">دقیقه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-row>
                    <v-col cols="4" class="mt-3">
                      <span class="filter-dialog-items-text">حداقل زمان ماموریت</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchMissionDurationMinimumSecond" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchMissionDurationMinimumMinute" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-3">
                      <v-spacer></v-spacer>
                      <span class="dot">:</span>
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="text" v-model="searchMissionDurationMinimumHoure" dense outlined
                        @keypress="isNumber($event)" v-on:keyup.enter="search()" class="input-label"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ثانیه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">دقیقه</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="filter-dialog-items-text-lable">ساعت</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-n3">
                  <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense
                    clearable autocomplete="off" @click:clear="clearDateTime('searchFromDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchFromDate"
                    @focus="showSearchFromDate = true" @click="showSearchFromDate = true" label="از تاریخ"
                    prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                    @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                    @close="showSearchFromDate = false" />
                </v-col>
                <v-col cols="12" class="mt-n7">
                  <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                    autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                    @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                    @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                    @close="showSearchToDate = false" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import QcMissionFenceTimesReportHelper from '@/Helpers/Report/QC/QcMissionFenceTimesReportHelper.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
export default {
  name: 'qcMissionFenceTimesReport',
  title: 'گزارش زمان های فنس',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
    AppGroupTableHeader,
  },
  mixins: [
    pagination,
    ShearedMixin,
    ReportMixin,
    QcMissionFenceTimesReportHelper,
    snackBar,
    ShearedHelper,
    UserMixin,
    VehicleTypeMixin,
    CityMixin,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.qcMissionFenceTimesReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getQCMissionFenceTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
      this.getAllUsersFunction();
      this.getListOfVehicleTypesForOther();
      this.getListOfCitysForOther();
    },
    previous: function () {
      this.getQCMissionFenceTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getQCMissionFenceTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getQCMissionFenceTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {},
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.dot {
  font-size: 25px;
  color: black;
}

.filter-dialog-items-text {
  font-size: 14px;
  color: #1c1b1f;
}

.filter-dialog-items-text-lable {
  font-size: 10px;
  color: #1c1b1f;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
